import type { WithIntlProps, IntlShape } from 'react-intl';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ArchiveUpsellDialog: LoadableType<
	WithIntlProps<{
		intl: IntlShape;
		showDeclineOption?: boolean;
	}>
> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ArchiveUpsellDialog" */ '../src/ArchiveUpsellDialog.tsx'
			)
		).ArchiveUpsellDialog,
});
